import { render, staticRenderFns } from "./centerModel.vue?vue&type=template&id=11eeb2d6&scoped=true"
import script from "./centerModel.vue?vue&type=script&lang=js"
export * from "./centerModel.vue?vue&type=script&lang=js"
import style0 from "./centerModel.vue?vue&type=style&index=0&id=11eeb2d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11eeb2d6",
  null
  
)

export default component.exports